import fvSubassembly from '../fvSubassembly'
import Vue from 'vue'
export default class fvPolylineObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system)
        this.initPoints = JSON.parse(JSON.stringify(this.points))
        //用于流动属性 不勾选“只有流动时才显示”时使用
        this.create()
        if (this.isDelayedWaiting) {
            this.complete = callback
        } else {
            callback(this)
        }
        //创建图元
        //添加折线
        this.polylineDom = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
        system.appendChild(this.polylineDom);
        if(this.renderType==4||this.renderType==5||this.renderType==6){
            this.polylineDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            this.system.insertBefore(this.polylineDefs, this.polylineDom);
        }
        this.createSucss(this.polylineDom, sContent);
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.polylinePath = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                system.appendChild(this.polylinePath);
            }
        }
        //创建样式
        this.parent = parent;
        this.system=system;
        this.createStyle();
    }
    createStyle() {
        this.setPosition();
        // 添加虚线属性
        super.chooseRenderType(this.lineType, this.polylineDom);
        this.setFillColor();
        this.polylineDom.style.fill = 'rgba(0, 0, 0, 0)';
        this.polylineDom.setAttribute('stroke-width', this.borderWidth);
        this.polylineDom.style.width = this.width + "px";
        this.polylineDom.style.height = this.height + "px";
        if (this.lineTypeStyle) {
            if (this.lineTypeStyle.isStereo) {
                this.polylinePath.innerHTML = "";
                this.drawStereo(this.polylinePath, this.polylineDom);
            }
        }
    }
    // 设置位置
    setPosition() {
        for (var i = 0; i < this.points.length; i++) {
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = (points0 * this.magnification.x + this.cx - this.parent.parentX) - this.borderWidth / 2;
            this.points[i][1] = (points1 * this.magnification.y + this.cy - this.parent.parentY) - this.borderWidth / 2;
        }
        this.polylineDom.setAttribute('points', this.points);
    }
    // 设置填充颜色
    setFillColor() {
        this.polylineDom.style.stroke = this.borderColor;
    }
    // 设置边框颜色
    setBorderColor() {
    }
    // 显示隐藏
    isShow(value) {
        value ? this.polylineDom.style.display = 'block' : this.polylineDom.style.display = 'none';
    }
    init() {
        super.init()
        // 根据x y 因边框、缩放改变导致绘制多折线重新计算
        for (var i = 0; i < this.points.length; i++) {
            var points0 = this.initPoints[i][0] + this.initPoints[i][0] * this.frameScaleX;
            var points1 = this.initPoints[i][1] + this.initPoints[i][1] * this.frameScaleY;
            this.points[i][0] = (points0 * this.magnification.x + this.cx - this.parent.parentX) - this.borderWidth / 2;
            this.points[i][1] = (points1 * this.magnification.y + this.cy - this.parent.parentY) - this.borderWidth / 2;
        }
    }
    onDraw() {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.polylineDom);
        this.polylineDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'}) rotate(${this.rotating + 'deg'}`;
        this.polylineDom.style.transformOrigin = `${this.originPinitX + "px"}  ${this.originPinitY + "px"}`;
    }
    //风格渲染
    Render() {
        if (this.renderConfig == undefined || JSON.stringify(this.renderConfig) == "{}") return;
        switch (this.renderType) {
            // case 1:  //模式1
            // case 2:  //模式2
            // case 3:  //模式3
            case 4:  //svg线性渐变效果
                this.linearGradient(this.uuid(), this.renderConfig, this.polylineDom, this.cx - this.parent.x, this.cy - this.parent.parentY,this.polylineDefs);
                break;
            case 5:  //svg路径渐变效果
                this.polylineDom.style.width = this.width;
                this.polylineDom.style.height = this.height;
                this.radialGradient(this.uuid(), this.renderConfig, this.polylineDom, this.cx - this.parent.x, this.cy - this.parent.parentY,this.polylineDefs);
                break;
            case 6:  //svg纹理渐变效果

                this.pattern(this.uuid(), this.polylineDom,this.polylineDefs);
                break;
            default:
                break;
        }
    }
    //生成path路径
    getPolylinePath(points) {
        var path = 
            'M' + points.slice(0,2).join(' ') +
            'L' + points.slice(2).join(' ');
        return path;
    }
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvPolylineObj.js